// Deriva cliente vinculado e responsável da conversa, pra pré-preencher o
// modal de "Criar tarefa" numa mensagem do atendimento.

export const resolveClienteAppIdFromConversa = (conversa) => {
  const conv = conversa || {}
  if (conv.id_cliente_app) return conv.id_cliente_app
  const contato = conv.contato || {}
  return contato.id_cliente_app || null
}

// Profissional atribuído à conversa, senão o usuário logado.
export const resolveResponsavelFromConversa = (conversa, currentUser) => {
  const conv = conversa || {}
  if (conv.assigned_to_id) {
    return {
      id: conv.assigned_to_id,
      nome: conv.assigned_to_nome || '',
      tipo: 'profissional',
    }
  }
  const user = currentUser || {}
  // id_interno é o identificador confiável (mesma convenção de crmTasksAdapter.js).
  const userId = user.id_profissional || user.id_interno
  if (userId) {
    return {
      id: userId,
      nome: user.nome || '',
      tipo: 'profissional',
    }
  }
  return null
}
